import {base} from './base';

export const gallery = base
  .extend('gallery')
  // Colors
  .property('primary.color', '#1E1E1E')
  .property('primary.font', 'Kumbh Sans')

  // border radius
  .property('border.radius', '0px')

  // Page
  .property('page.background.color', '#FFFFFF')

  // Headings
  .property('heading1.font', 'Poppins')

  // Text
  .property('text.font', 'Kumbh Sans')
  .property('text.color', '#1E1E1E')

  // Menu
  .property('menu.background.color', '#FFFFFF')
  .property('menu.text.color', '#1E1E1E')
  .property('menu.text.font', 'Kumbh Sans')

  // Image
  .property(
    'image.default',
    'https://images.teemill.com/c7sm2tssk2o2jqo00uuidoujwit4xmlr7m9tyohcmjeguuoq.jpg'
  )

  // Quote
  .property('quote.text.color', '#232323')
  .property('quote.fullBackground.color', '#FFFFFF')

  // AnnouncementV2
  .property('announcement.v2.text.color', '#FFFFFF')
  .property('announcement.v2.background.color', '#9B6363FF')

  // Newsletter
  .property('newsletter.text.color', '#181818')
  .property('newsletter.fullBackground.color', '#FFFFFF')

  //Footer
  .property('footer.visible', '1')
  .property('footer.text.color', '#1E1E1E')
  .property('footer.background.color', '#FFFFFF');
